<template>
  <a
    class="c-facebook-icon-link"
    :href="href"
    target="_blank"
  >
    <svg
      width="31px"
      height="31px"
      viewBox="0 0 31 31"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>Facebook</title>

      <g
        id="Navigation"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="M-Nav"
          transform="translate(-96.000000, -907.000000)"
          fill="#14457f"
          fill-rule="nonzero"
        >
          <g
            id="Group"
            transform="translate(96.000000, 907.000000)"
          >
            <g id="Icon_facebook">
              <path
                id="Shape"
                d="M15.5,0 C6.92941176,0 0,6.92941176 0,15.5 C0,24.0705882 6.92941176,31 15.5,31 C24.0705882,31 31,24.0705882 31,15.5 C31,6.92941176 24.0705882,0 15.5,0 Z M20.3323529,8.93529412 L18.6,8.93529412 C17.2323529,8.93529412 16.9588235,9.57352941 16.9588235,10.5764706 L16.9588235,12.6735294 L20.2411765,12.6735294 L19.7852941,16.0470588 L16.8676471,16.0470588 L16.8676471,24.6176471 L13.4029412,24.6176471 L13.4029412,16.0470588 L10.4852941,16.0470588 L10.4852941,12.6735294 L13.4029412,12.6735294 L13.4029412,10.2117647 C13.4029412,7.38529412 15.1352941,5.83529412 17.6882353,5.83529412 C18.8735294,5.83529412 19.9676471,5.92647059 20.2411765,5.92647059 L20.2411765,8.93529412 L20.3323529,8.93529412 Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </a>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: "http://www.facebook.com/EnsoRings"
    }
  }
}
</script>

<style lang="scss" scoped>
.c-facebook-icon-link {
  height: 31px;
}
</style>
